
import '../style/Footer.css';
const Footer = () => {
  return (
    <>
      <div id='footer'>
          <a class="button-86" role="button" href='https://wa.me/+201025374656'>Developed By : Uncle Sam Team</a>
      </div>
    </>
  )
}

export default Footer;